export const buildProjectClientMailUrl = (project) => {
  const email = String(project?.requester_email || "").trim();
  if (!email) return null;

  const eventName = String(project?.event_name || "").trim() || "Untitled Event";
  const requestCode = String(project?.request_code || "").trim();
  const subject = requestCode ? `${eventName} (${requestCode})` : eventName;

  const params = new URLSearchParams({
    view: "cm",
    fs: "1",
    to: email,
    su: subject,
  });

  return `https://mail.google.com/mail/?${params.toString()}`;
};

export const openProjectClientMail = (project) => {
  const url = buildProjectClientMailUrl(project);
  if (!url) return false;
  window.open(url, "_blank", "noopener,noreferrer");
  return true;
};
